import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../shared/shared.module';
import { FourOhFourRoutingModule } from './four-oh-four-routing.module';
import { FourOhFourComponent } from './four-oh-four.component';
import { NgxMaskModule, IConfig } from 'ngx-mask'

export const options: Partial<IConfig> | (() => Partial<IConfig>) = null;

@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        NgxMaskModule.forRoot(),
        SharedModule,
        FourOhFourRoutingModule
    ],
    declarations: [FourOhFourComponent],
    exports: [FourOhFourComponent],
    providers: []
})
export class FourOhFourModule {}
